import { z } from "zod";

/** Same strength rule as the borrower portal. */
const STRONG_PASSWORD =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+\-=])[A-Za-z\d@$!%*?&#^()_+\-=]{6,}$/;

const STRONG_PASSWORD_MESSAGE =
  "Password must contain at least one uppercase, one lowercase, one number, and one special character";

export const OTP_LENGTH = 4;
export const OTP_RESEND_SECONDS = 30;

export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, "Enter a valid email")
    .email("Enter a valid email")
    .transform((value) => value.toLowerCase()),
});

const newPasswordSchema = z
  .string()
  .min(6, "Minimum 6 characters required")
  .regex(STRONG_PASSWORD, STRONG_PASSWORD_MESSAGE);

export const resetPasswordSchema = z
  .object({
    code: z
      .string()
      .trim()
      .min(1, "Please enter email OTP")
      .regex(new RegExp(`^\\d{${OTP_LENGTH}}$`), `Please enter the ${OTP_LENGTH}-digit OTP`),
    password: newPasswordSchema,
    confirmPassword: z.string().min(1, "Please confirm your password"),
  })
  .refine((value) => value.password === value.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

export function zodFieldErrors(error: z.ZodError): Record<string, string> {
  const next: Record<string, string> = {};
  for (const issue of error.issues) {
    const key = String(issue.path[0] ?? "form");
    if (!next[key]) next[key] = issue.message;
  }
  return next;
}
